import gql from "graphql-tag";

export const SEARCH_VENDORS = gql`
	query searchVendors($searchTerm: String!, $offset: Int = 0, $take: Int = 500) {
		response: searchVendors(searchTerm: $searchTerm, skip: $offset, take: $take) {
			items {
				vendorId
				companyName
				addresses {
					vendorAddressId
					label
					addressLine1
					addressLine2
					addressTypeId
					city
					state
					postalCode
					isPrimaryAddress
				}
				contacts {
					vendorContactId
					primaryContact
					firstName
					lastName
					workPhoneNumber
					cellPhoneNumber
					email
					isActive
				}
			}
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;

export const VENDOR_BY_ID = gql`
	query vendorById($id: Int!) {
		response: vendorById(id: $id) {
			vendorId
			companyName
			addresses {
				vendorAddressId
				label
				addressLine1
				addressLine2
				addressTypeId
				city
				state
				postalCode
				isPrimaryAddress
			}
			contacts {
				vendorContactId
				primaryContact
				firstName
				lastName
				workPhoneNumber
				cellPhoneNumber
				email
				isActive
			}
		}
	}
`;
